import {
  AccountType,
  ICheckboxConfig,
  ICheckboxGroupValue,
  IOptionGroup,
} from "component-library";

import {
  IWithSelfTapeRequestNotificationsFilterOptions,
  IWithSelfTapeRequestNotificationsFilterTexts,
} from "./withSelfTapeRequestNotificationsFilter";

export const DEFAULT_PAGE_NUMBER = 1;

export enum FilterType {
  Client = "client",
  DateReceived = "dateReceived",
  PageNumber = "pageNumber",
  MediaRequestType = "mediaRequestType",
}

export interface IFilterModel {
  [FilterType.Client]?: ICheckboxGroupValue;
  [FilterType.MediaRequestType]?: ICheckboxGroupValue;
  [FilterType.DateReceived]: Date[] | undefined;
  [FilterType.PageNumber]: number;
}

export enum FilterControlType {
  DatePicker = "datePicker",
  Checkbox = "checkbox",
  Dropdown = "dropdown",
}

export interface IFilterConfigItem {
  translations: string;
  defaultValue: any;
  filterControlType?: FilterControlType;
  drawerFilterControlType?: FilterControlType;
  dropdownOptions?: IOptionGroup<number>[];
  checkboxOptions?: ICheckboxConfig[];
}

export interface ISelfTapeRequestNotificationSender {
  id: string;
  name: string;
}

export type IFilterConfigPerformer = Record<
  keyof Pick<IFilterModel, FilterType.Client | FilterType.DateReceived>,
  IFilterConfigItem
>;

export type IFilterConfigAgent = Record<
  keyof Pick<IFilterModel, FilterType.DateReceived>,
  IFilterConfigItem
>;

export type IFilterConfig = IFilterConfigPerformer | IFilterConfigAgent;

export interface ISetupFilterConfigParams
  extends Omit<IWithSelfTapeRequestNotificationsFilterOptions, "tab"> {
  filterControlTexts: IWithSelfTapeRequestNotificationsFilterTexts;
  userType: AccountType;
  performers: { id: string; name: string }[];
}

export const DEFAULT_VALUES = {
  [FilterType.Client]: {},
  [FilterType.MediaRequestType]: {},
  [FilterType.DateReceived]: undefined,
  [FilterType.PageNumber]: DEFAULT_PAGE_NUMBER,
};
